import React from "react";
import showIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-show-table.svg";
import hideIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-hide-table.svg";

export const ShowHideSubTable = ({ showTable, setShowTable, subId }) => {
  const handleClick = () => {
    if (showTable === subId) {
      setShowTable("");
    } else {
      setShowTable(subId);
    }
  };
  return (
    <img
      src={showTable === subId ? hideIcon : showIcon}
      alt={showTable === subId ? "Hide Icon" : "Show Icon"}
      width={25}
      height={25}
      onClick={handleClick}
      className="show-hide-subtable-icon"
    />
  );
};
